import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import Notification from '../../components/Notification';
class Popups extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading:true,
			isError:false,
			askDelete:false,
			popups:[],
		}

		this.rows = this.rows.bind(this);
		this.export = this.export.bind(this);
		this.duplicate = this.duplicate.bind(this);
	}

	placeholder() {
		return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
	}

	export(id) {
		this.setState({
			isLoading:true,
		});
		axios.get('/popups/'+id+'/export').then(res => {
            this.setState({
                isLoading:false,
            });
            document.location = res.data.url;
		});
	}

	changeStatus = (id,status) => {
		let popups = [
			...this.state.popups
		];
        if(this.props.general.settings.PACKAGE_POPUP != "1") {
            Notification.error("You're not subscribed to the platform package.");
            return;
        }

		axios.put('/popups/'+id+'/status',{});

		popups = popups.map(function(popup) {
			if(popup.id == id) {
				popup.status = status == 1 ? 0:1;
			}

			return popup;
		});

		this.setState({
			popups:popups
		})
	}

    duplicate(id) {
        this.setState({
            isLoading:true,
        });

        axios.post('/popups/'+id+'/duplicate').then((res) => {
            this.setState({isLoading:false});
            this.props.router.push(General.Link('/builder/popup/'+res.data.id));
        });
    }

	rows() {
		let data = this.placeholderRow(10,7);

		this.state.popups.map((popup,i) => {
			data[i] =
				<tr key={`popup-${popup.id}`}>
					<td>#{popup.id}</td>
					<td>{popup.name}</td>
					<td>{popup.views}</td>
					<td>{popup.leads}</td>
					<td>{popup.rate}%</td>

                    <td style={{cursor:'pointer'}} onClick={() => this.changeStatus(popup.id,popup.status)} className={`column-status s-${popup.status}`}>
						<Tooltip placement="top" overlay={`${(popup.status == 1 ? 'Click here to deactivate popup':'Click here to activate popup')}`}>
							<span>{popup.status == 1 ? <i className="icon wb-check"></i>:<i className="icon wb-close"></i>}</span>
						</Tooltip>
                    </td>

					<td>
						<div className="btn-group" role="group">
							<Tooltip placement="top" overlay={<span>Export subscribers</span>}>
								<button onClick={(e) => {this.export(popup.id)}} type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-print" aria-hidden="true"></i></button>
							</Tooltip>
							<Tooltip placement="top" overlay={<span>Edit popup</span>}>
	                    		<Link to={General.Link(`/builder/popup/${popup.id}`)} className="btn btn-icon btn-default btn-outline"><i className="icon wb-pencil" aria-hidden="true"></i></Link>
	                    	</Tooltip>

							<Tooltip placement="top" overlay={<span>Duplicate popup</span>}>
								<button onClick={() => this.duplicate(popup.id)} className="btn btn-icon btn-default btn-outline"><i className="icon wb-copy" aria-hidden="true"></i></button>
							</Tooltip>

	                    	<Tooltip placement="top" overlay={<span>Delete popup</span>}>
	                    		<button onClick={(e) => {this.askDelete(popup.id)}} type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-trash" aria-hidden="true"></i></button>
	                    	</Tooltip>
	                    </div>
					</td>
				</tr>

		})

		return data;
	}

	askDelete(id) {
		this.setState({askDelete:id});
	}

	delete(id) {
		this.setState({askDelete:false,isLoading:true});
		axios.delete('/popups/'+id).then(res => {
			axios.get(`/popups`)
			.then(res => {
				this.setState({
					'isError':false,
					'isLoading':false,
					'popups':res.data
				});
			});
		});
	}

	placeholderRow(rows,cols) {
		let td = [];
		for(let i = 1;i<=cols;i++) {
			td.push(<td key={i}>{this.placeholder()}</td>);
		}

		let row = [];
		for(let i = 1;i<=rows;i++) {
			row.push(<tr key={i}>{td}</tr>);
		}

		return row;
	}

	componentWillMount() {
		axios.get(`/popups`)
		.then(res => {
			this.setState({
				...this.state,
				'isError':false,
				'isLoading':false,
				'popups':res.data
			});
		})
		.catch(res => {
			this.setState({'isError':res.message});
		});
	}

	render() {
		if(this.state.isLoading) {
			return (
				<Loading error={this.state.isError} />
			);
		}

		if(this.state.popups.length == 0) {
			return (

				<div className="page-content">
					<Helmet title="Popups | Crall.io" />
					<NoResult
						header="No popups found"
						body="You have not created a popup yet. Click the button to get started."
						link="/builder/popup/picker"
						button="Create my first popup"
					/>

				</div>
			);
		}

		return (
			<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-layout"></i> Popups</span>
					<div className="page-header-actions">
				        <Link to={General.Link("/builder/popup/picker")} className="btn btn-dark"><i className="icon fa-plus" style={{marginRight:'10px'}}></i>  New</Link>
				    </div>
				</div>
			<div className="page-content">
			<div className="col-sm-12 p-0">
				<Helmet title="Popups | Crall.io" />

				<table className="table outline">
					<tbody>
						<tr>
							<th>#</th>
							<th>Name</th>
							<th>Views</th>
							<th>Leads</th>
							<th>Conversion rate</th>
							<th>Status</th>
							<th>Actions</th>
						</tr>
					</tbody>



					<tbody>
						{this.rows()}
					</tbody>
				</table>
				<Confirm onAccept={(e) => { this.delete(e) }} onClose={() => {this.setState({askDelete:false})}} param={this.state.askDelete} title="Are you sure?" body="Do you want to delete this popup?" />
			</div>
			</div>
			</div>

		)

	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
        general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Popups = connect(mapStateToProps,mapDispatchToProps)(Popups);
export default Popups;



// WEBPACK FOOTER //
// ./containers/popups/popups.js